import React from 'react';
import type { EmpleadosContadores, EstadoListado } from '../../api/empleadosApi';
import { FctSegmentado } from '../../fct/react';

interface Props {
  /** Panorama completo (sin filtros); `null` mientras llega o si falló. */
  contadores: EmpleadosContadores | null;
  /** Estado que filtra el listado ahora. */
  estado: EstadoListado;
  /** Clic en Total, Activos o De baja: aplica ese estado al listado. */
  onEstado: (estado: EstadoListado) => void;
}

/**
 * Pestañas de estado del listado (D-EMP-16): total, activos y de baja, que a la vez filtran por estado.
 * Los números son los de todos los empleados, no los del filtro actual. El reparto por delegación vive
 * en el panel «Métricas» (`MetricasEmpleados`).
 */
export const ContadoresEmpleados: React.FC<Props> = ({ contadores, estado, onEstado }) => (
  <div style={{ marginBottom: 12 }}>
    <FctSegmentado<EstadoListado>
      etiquetaAccesible="Contadores de empleados"
      valor={estado}
      onCambio={onEstado}
      opciones={[
        { valor: 'todos', etiqueta: 'Total', contador: contadores?.total },
        { valor: 'activos', etiqueta: 'Activos', contador: contadores?.activos },
        { valor: 'bajas', etiqueta: 'De baja', contador: contadores?.bajas },
      ]}
    />
  </div>
);
